import React, { useState } from "react";
import styles from "./EmployeeCard.module.css";
import { Switch } from "antd";
import { API } from "../../../../request/api";
import { useTranslation } from "react-i18next";
import { Note } from "../../../../helbest";

export default function EmployeeCard({
  id,
  full_name,
  mobile_number,
  number_of_bills,
  is_active,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(is_active);
  const { t } = useTranslation();

  const updateIsActive = (isActive) => {
    setIsLoading(true);
    API.put
      .updateEmployee(id, isActive)
      .then((response) => {
        if (response.success) {
          setIsActive(isActive);
          Note.success(t("employees.messages.updated"));
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={styles.card}>
      <div>Active</div>
      <div>
        <Switch
          checked={isActive}
          onChange={(checked) => updateIsActive(checked)}
          loading={isLoading}
        />
      </div>
      <div>{t("employees.card.name")}</div>
      <div>{full_name}</div>
      <div>{t("employees.card.phone_number")}</div>
      <div>{mobile_number}</div>
      <div>{t("employees.card.number_of_bills")}</div>
      <div>{number_of_bills}</div>
    </div>
  );
}
